module.exports = __webpack_public_path__ + "logo.png?65a3f7f0fb46135bd28b8dae49206f36";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 503
// module chunks = 0